// extracted by mini-css-extract-plugin
export default {"container":"SearchBox_container__LBPHE","small":"SearchBox_small__Z+fB1","medium":"SearchBox_medium__V6PfE","large":"SearchBox_large__ophqU"};